export default __webpack_public_path__ + "static/media/tickets3.b584182a.svg";